import utils from '../../assets/js/utils'
export default {
  className: 'trip',
  fields: [
    {
      name: 'direction',
      note: '方向',
      width: 150
    },
    {
      name: 'mode',
      width: 150
    },
    {
      name: 'startPlace',
      width: 200,
      render (record) {
        return `${record.startPlace.city}-${record.startPlace.district}-${record.startPlace.title}`
      }
    },
    {
      name: 'endPlace',
      width: 200,
      render (record) {
        return `${record.endPlace.city}-${record.endPlace.district}-${record.endPlace.title}`
      }
    },
    {
      name: 'travelTime'
    },
    {
      name: 'passengers',
      width: 150,
      render (record) {
        return `${record.passengers}人`
      }
    },
    {
      name: 'phone',
      width: 150
    },
    {
      name: 'remarks',
      width: 200
    }
  ],
  search: [
    'direction',
    // 'mode',
    'travelTime',
    'passengers',
    'phone'
  ],
  action: {
    export: false,
    create: false,
    delete: false,
    edit: false,
    copy: {
      type: 'row',
      text: '复制',
      callback: async ({ record, vm, modelName }) => {
        utils.copy(record, vm)
      }
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      where.status = 'cancel'
    }
  }
}
